/**
 * Viewport breakpoint utilities — single source of truth for mobile / tablet
 * detection across the workspace (mirrors mobile.css :17 @media breakpoint).
 *
 * Any module that needs to "is this mobile / tablet?" or "react when the
 * viewport crosses the breakpoint" should consume from here, not redefine
 * its own breakpoint constant.
 *
 * Aligned with apps/creator-hub/css/mobile.css:
 *   - mobile  : @media (max-width: 767px)
 *   - tablet  : @media (min-width: 768px) and (max-width: 1023px)
 *   - desktop : @media (min-width: 1024px)
 */

export const MOBILE_MAX_WIDTH = 767
export const TABLET_MIN_WIDTH = 768
export const TABLET_MAX_WIDTH = 1023
export const DESKTOP_MIN_WIDTH = 1024

export const MOBILE_MQ = `(max-width: ${MOBILE_MAX_WIDTH}px)`
export const TABLET_MQ = `(min-width: ${TABLET_MIN_WIDTH}px) and (max-width: ${TABLET_MAX_WIDTH}px)`
export const DESKTOP_MQ = `(min-width: ${DESKTOP_MIN_WIDTH}px)`

export function isMobile() {
  return window.innerWidth <= MOBILE_MAX_WIDTH
}

export function isTablet() {
  return window.innerWidth >= TABLET_MIN_WIDTH && window.innerWidth <= TABLET_MAX_WIDTH
}

export function isDesktop() {
  return window.innerWidth >= DESKTOP_MIN_WIDTH
}

export function getMobileMatchMedia() {
  return window.matchMedia(MOBILE_MQ)
}

export function getTabletMatchMedia() {
  return window.matchMedia(TABLET_MQ)
}
